import { ReactComponent as InfoIcon } from "assets/products/shared/icons/info.svg";

import ModalTemplate from "components/modal/modal-template/ModalTemplate";

const InfoSecondaryAddresseeModal = () => {
    return (
        <ModalTemplate
            trigger={
                <InfoIcon
                    className="w-4 h-4 cursor-pointer"
                    data-testid="info-coverage-replacement-trigger"
                    tabIndex={-1}
                    onMouseDown={(e) => e.preventDefault()}
                    onFocus={(e) => e.stopPropagation()}
                />
            }
            modalId="info-policy-beneficiary-modal"
            className="p-0 tablet:max-w-[600px] max-w-[370px]"
        >
            <div className="p-6 font-sans text-base font-medium leading-6 text-black space-y-4 [&_p]:text-black text-left">
                <p className="font-bold">Reminder: This is not a cosigner. </p>
                <p>
                    If your insurance premium becomes outstanding, and you would like us to mail a notification to an additional
                    person at that time, you can enter their information here.
                </p>
                <p>This is optional.</p>
            </div>
        </ModalTemplate>
    );
};

export default InfoSecondaryAddresseeModal;
